export const loggedUser_actionType = {
    GET_LOGGED_USER_SUCCESS : 'GET_LOGGED_USER_SUCCESS',
    GET_LOGGED_USER_FAILURE : 'GET_LOGGED_USER_FAILURE'
};